import $ from 'jquery';

export function currency() {
    if($(".price-section__sum").length)
    {
        let regex = /\d+/g;
        let string = $(".price-section__sum").text();
        let matches = string.match(regex); 

        let usdCurrencyPerFourMonth = Math.round(matches[0] / $(".course-single-wrapper").attr("data-rate"));

        
        let uah_currency = $(".price-section__sum span").text();

        $(".price-section__sum").html(parseInt(matches[0]).toLocaleString('ru') + " <span class='valign'>" + uah_currency + "</span> / <span>" + usdCurrencyPerFourMonth.toLocaleString('ru') + " <span class='valign'>" + usd_currency + "</span></span>");


        //смарт
        string = $(".smart-panel__item.smart-panel__price .smart-panel__text.full").text();
        let str = string.replace(/\s/g, '');

        let cost = "";
        for(let i = 0; i < str.length; i ++)
        {
            if(/^\d+$/.test(str[i]) == true)
            {
                cost += str[i];
            }
            else break;
        }


        $(".smart-panel__item.smart-panel__price .smart-panel__text.full").html(parseInt(cost).toLocaleString('ru') + " <span>" + uah_currency + "</span> / <span>" + usdCurrencyPerFourMonth.toLocaleString('ru') + " <span>" + usd_currency + "</span></span>");

        string = $(".smart-panel__item.smart-panel__price .smart-panel__text.months").text();
        str = string.replace(/\s/g, '');
        cost = "";
        for(var i = 0; i < str.length; i ++)
        {
            if(/^\d+$/.test(str[i]) == true)
            {
                cost += str[i];
            }
            else break;
        }

        let usdCurrencyPerMonth = Math.round(cost / $(".course-single-wrapper").attr("data-rate"));
        $(".smart-panel__item.smart-panel__price .smart-panel__text.months").html(parseInt(cost).toLocaleString('ru') + " <span>" + uah_currency + "</span> / <span>" + usdCurrencyPerMonth.toLocaleString('ru') + " <span>" + usd_currency + "</span></span>");


        let dateText = $(".smart-panel__item.smart-panel__days .smart-panel__text").text();
        let dateTextFirst = dateText.substring(0, dateText.indexOf("|") + 1);
        let dateTextSecond = dateText.substring(dateText.indexOf("|") + 1);
        $(".smart-panel__item.smart-panel__days .smart-panel__text").html(dateTextFirst + " <span>" + dateTextSecond + "</span>");

        
        //карточка
        let changeCurrency = false; 

        $(".learn-section__switcher .switcher").on("click", function() {
            $(".learn-section__switcher .switcher .switcher-point").toggleClass("switched");

            changeCurrency = !changeCurrency 
            if(changeCurrency)
            {
                $(".learn-section__switcher .uk").css("opacity", "0.5");
                $(".learn-section__switcher .us").css("opacity", "1");
                $(".learn-section__bottom.uk").css("visibility", "hidden");
                $(".learn-section__bottom.us").css("visibility", "visible");
                $(".learn-section__bottom.uk").css("opacity", "0");
                $(".learn-section__bottom.us").css("opacity", "1");
            }
            else {
                $(".learn-section__switcher .uk").css("opacity", "1");
                $(".learn-section__switcher .us").css("opacity", "0.5");
                $(".learn-section__bottom.uk").css("visibility", "visible");
                $(".learn-section__bottom.us").css("visibility", "hidden");
                $(".learn-section__bottom.uk").css("opacity", "1");
                $(".learn-section__bottom.us").css("opacity", "0");
            }
        });

        $(".learn-section__bottom.us .learn-section__price").html(usdCurrencyPerFourMonth + " <span>" + usd_currency + "</span>")
        $(".learn-section__bottom.us .learn-section__month-price").html(usdCurrencyPerMonth + " " + usd_currency +  " / " + $(".learn-section__bottom.uk .learn-section__month-price").text().substring($(".learn-section__bottom.uk .learn-section__month-price").text().indexOf("/") + 1));
        
        $(".learn-section__switcher span.uk").text(uah_currency);
        $(".learn-section__switcher span.us").text(usd_currency);
    }

    
}


// WEBPACK FOOTER //
// app/scripts/components/currency.js